module.exports = __webpack_public_path__ + "static/img/3s-info-b3.566a498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-info-b3.png
// module id = 1juE
// module chunks = 0